import { SET_MAINTENANCE_SERVICES, ADD_MAINTENANCE_NOTES } from './actionTypes';
import { ERROR_MAINTENANCE } from 'store/reducers/errors/actionTypes';
import { getIndividualServices } from 'store/reducers/individualServices/actions';
import { getMaintenanceServices as getMaintenanceServicesFromStore } from 'store/reducers/maintenance/selectors';
import { SERVICES_KIND } from 'constants/services';

// Selectors
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';

const { MAINTENANCE } = SERVICES_KIND;

export const getMaintenanceServices = () => async (dispatch, getState) => {
  if (
    getPolicyProperty(getState())('maintenanceSvcVisible') !== '0' &&
    getMaintenanceServicesFromStore(getState()).length === 0
  ) {
    await dispatch(
      getIndividualServices(MAINTENANCE, SET_MAINTENANCE_SERVICES)
    );
  }
  if (getPolicyProperty(getState())('maintenanceSvcVisible') === '0') {
    dispatch({
      type: ERROR_MAINTENANCE,
      payload: true
    });
  }
};

export const setMaintenanceServices = maintenanceServices => ({
  type: SET_MAINTENANCE_SERVICES,
  payload: maintenanceServices
});

export const addMaintenanceNotes = (notes, serviceId) => ({
  type: ADD_MAINTENANCE_NOTES,
  payload: { notes, serviceId }
});



// WEBPACK FOOTER //
// ./src/store/reducers/maintenance/actions.js